import dynamic from 'next/dynamic';

import { toPX, toPXCombo } from '#app/helpers/toPX';
import useWindowSize from '#app/hooks/useWindowSize';

import { typo_24 } from '../../UI/atoms/typography/typography.module.scss';
import styles from './index.module.scss';

const Typography = dynamic(() => import('../../UI/atoms/typography/typography'));

const Contact = ({
  title,
  description,
  paddingTop,
  paddingBottom,
  children,
  margin,
  padding,
  gap,
  id,
  text,
  form
}) => {
  const { isDesktop } = useWindowSize();

  return (
    <section className={styles.wrapper} id={id}>
      <div
        className={styles.container}
        style={{
          padding: toPXCombo(isDesktop, padding),
          margin: toPXCombo(isDesktop, margin),
          paddingTop: paddingTop && toPX(isDesktop, paddingTop),
          paddingBottom: paddingBottom && toPX(isDesktop, paddingBottom),
          gap: gap && toPX(isDesktop, gap)
        }}
      >
        {/* Text */}
        <div
          className={styles.text}
          style={{ width: text && toPX(isDesktop, text.width) }}
        >
          <Typography
            fontSize={[48, 24]}
            lineHeight={[56, 32]}
            fontWeight={700}
            color="white"
            tag="h2"
          >
            {title}
          </Typography>

          <Typography variant={typo_24} fontWeight={400} color="white" tag="p">
            {description}
          </Typography>
        </div>

        {/* Form */}
        <div
          className={styles.form}
          style={{ width: form && toPX(isDesktop, form.width) }}
        >
          {children}
        </div>
      </div>
    </section>
  );
};

export default Contact;
